module.exports = __webpack_public_path__ + "static/media/news2.d93d1d27.jpg";